export default __webpack_public_path__ + "static/media/Delta-Carpets-Back-1.575817d2.png";